import { Field, withDatasourceCheck } from '@sitecore-jss/sitecore-jss-nextjs';
import { ComponentProps } from 'lib/component-props';
import { FaFacebookSquare, FaLinkedin, FaPhoneSquareAlt, FaYoutube } from "react-icons/fa";
import { Form, createDefaultFieldFactory, FieldTypes } from '@sitecore-jss/sitecore-jss-react-forms';
import InputComponent from 'components/CustomContactUsForm/InputComponent';
import EmailComponent from 'components/CustomContactUsForm/EmailComponent';


type ContacusFormProps = ComponentProps & {
  fields: {
    heading: Field<string>;
  };
  locale?: string;
  lang?: string;
};

const ContacusForm = ({ fields }: any): JSX.Element => {
  //Variables
  const heading = fields?.fields[0]?.model?.text;
  const title = fields?.fields[1]?.model?.text
  const subtitle = fields?.fields[2]?.model?.text;
  const linkedin = fields?.fields[3]?.model?.text;
  const youtube = fields?.fields[4]?.model?.text;
  const facebook = fields?.fields[5]?.model?.text;
  const phone = fields?.fields[6]?.model?.text;
  const defaultFieldFactory = createDefaultFieldFactory();

  //Functions
  defaultFieldFactory.setComponent(FieldTypes.SingleLineText, (props: any): any => <InputComponent {...props} />);
  defaultFieldFactory.setComponent(FieldTypes.Email, (props: any): any => {
    let tempProps={...props,contactus:true}
    return(
      <EmailComponent {...tempProps} />
    )
  })
  defaultFieldFactory.setComponent(FieldTypes.TextField, (): any => <></>)
  const fieldvalidation = (props: any) => {
    return (
      <div className='mb-4'>
        {props.formErrors}
      </div>
    )

  }
  return (
    <>

      <section className="py-20 xl:py-40 bg-theme-color ">
        <div
          className={`grid lg:grid-cols-2 responsive gap-y-10 lg:gap-y-0 lg:gap-x-20`}
        >
          <div className="flex flex-col text-theme-color gap-y-5">
            <p className="font-bold text-4brand">{heading ? heading : ""}</p>
            <p className="font-bold leading-tight text-3brand">
              {title ? title : ""}
            </p>
            <p className="text-opacity-50 lg:w-2/3">
              {subtitle ? subtitle : ""}
            </p>
            <div className="flex items-center text-3brand gap-x-8">
              <a href={linkedin} target={"_blank"} rel="noopener noreferrer" className="transition-colors duration-300 hover:text-brand-800">
                <FaLinkedin />
              </a>
              <a href={youtube} target={"_blank"} rel="noopener noreferrer" className="transition-colors duration-300 hover:text-brand-800">
                <FaYoutube />
              </a>
              <a href={facebook} target={"_blank"} rel="noopener noreferrer" className="transition-colors duration-300 hover:text-brand-800">
                <FaFacebookSquare />
              </a>
              <a href={phone} className="transition-colors duration-300 hover:text-brand-800">
                <FaPhoneSquareAlt  />
              </a>
            </div>
          </div>

          <div className="flex flex-col gap-y-5 lg:gap-y-10">
            <Form
              form={fields}
              sitecoreApiHost={""}
              sitecoreApiKey={process.env.NEXT_PUBLIC_SC_KEY || ""}
              fieldFactory={defaultFieldFactory}
              errorComponent={fieldvalidation}
            />
          </div>


        </div>
      </section>

    </>
  );
}


export default withDatasourceCheck()<ContacusFormProps>(ContacusForm);
